import React, { useState } from "react";
import axios from "axios";

export default function VoiceOrder() {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [listening, setListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [cart, setCart] = useState([]);

  const startListening = () => {
    const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = (event) => {
      const text = event.results[0][0].transcript;
      setTranscript(text);
      sendTranscript(text);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
    };

    recognition.onend = () => setListening(false);

    setListening(true);
    recognition.start();
  };

  const sendTranscript = async (text) => {
    try {
      const response = await axios.post(baseUrl+"/voice-order/", { transcript: text });
      setCart(response.data.items);
      // Optionally auto-redirect to confirmation
      // window.location.href = `/order/confirm/${response.data.order_id}`;
    } catch (err) {
      console.error("Error sending transcript:", err);
    }
  };

  return (
    <div className="p-4 mt-6 border rounded-lg">
      <h2 className="text-xl font-bold mb-2">Voice Order Upload</h2>

      <button
        onClick={startListening}
        disabled={listening}
        className="bg-blue-500 text-white px-4 py-2 rounded-lg"
      >
        {listening ? "Listening..." : "Start Voice Input"}
      </button>

      {transcript && (
        <p className="mt-3 italic">You said: “{transcript}”</p>
      )}

      {cart.length > 0 && (
        <div className="mt-4">
          <h3 className="font-semibold">Detected Items:</h3>
          <ul className="list-disc ml-5">
            {cart.map((item, i) => (
              <li key={i}>
                {item.quantity} × {item.name}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
